import ReloginPage from './ReloginPage'

export default ReloginPage
